import React, { useMemo, useState } from 'react'
import { LocationPinPoint } from '~/@mid_ui/icons/LocationPinPointIcon'
import { _killPropagation } from '~/@lib/utils/ui.utils'
import type {
  ProjectSchema,
  ProjectsItem,
} from '../../_project_types/project.types'
import { ProjectPopup } from '../project-popup-components/ProjectPopup'
import { ProjectLabel } from '../project-popup-components/ProjectLabel'
import { ProjectMedium } from '../project-media/ProjectMedium'

type Props = {
  project: ProjectSchema | ProjectsItem
  withPopup: boolean
}

function ProjectPreviewImageAndPopup({ project, withPopup }: Props) {
  const [isOpenPopup, setOpenPopup] = useState<boolean>(false)
  return (
    <>
      <ImagePreview
        projectId={project._id}
        images={(project?.images ?? []).filter(
          (image) =>
            (image.typeId === 'collateralImage' || image.typeId === 'image') &&
            !image.contentType.startsWith('video/')
        )}
        handleOpenPopup={(e?: React.MouseEvent<any, any>) => {
          _killPropagation(e)
          if (withPopup) setOpenPopup(true)
        }}
      />
      {withPopup && (
        <ProjectPopup
          project={project}
          isOpen={isOpenPopup}
          handleClosePopup={(
            e?: React.MouseEvent<HTMLButtonElement, MouseEvent>
          ) => {
            e?.stopPropagation()
            setOpenPopup(false)
          }}
        />
      )}
      <ProjectLabel
        location={project.location}
        subcategory={project.collateralInfo?.collateralSubcategory}
        category={project.collateralInfo?.collateralCategory}
      />
    </>
  )
}

function ImagePreview(props: {
  projectId: string
  images: ProjectsItem['images']
  handleOpenPopup: () => void
}) {
  const imagePreviewUrl = useMemo(() => {
    const { images } = props
    if (!images[0]?.sizes?.length) return null

    const imageBySize = images[0].sizes?.find((image) => image.width === 400)
    if (!imageBySize) return null

    return imageBySize.path
  }, [props])

  return (
    <button
      onClick={props.handleOpenPopup}
      className="relative h-[44px] w-[44px] cursor-pointer transition-transform duration-700 hover:scale-110">
      {imagePreviewUrl ? (
        <ProjectMedium projectId={props.projectId} filename={imagePreviewUrl}>
          {(blob) => (
            <img
              width={44}
              height={44}
              className="h-full w-full rounded-[5px] object-cover pointer-events-none"
              src={URL.createObjectURL(blob)}
              alt="Project Preview"
            />
          )}
        </ProjectMedium>
      ) : (
        <img
          width={44}
          height={44}
          className="h-full w-full rounded-[5px] object-cover pointer-events-none"
          src="/favicon/favicon.svg"
          alt="Project Preview"
        />
      )}
      <div className="absolute bottom-0 right-0 flex h-5 w-5 items-center justify-center rounded-[5px] bg-[#006EF0] pointer-events-none">
        <LocationPinPoint />
      </div>
    </button>
  )
}

export { ProjectPreviewImageAndPopup }
